import { gql } from "@apollo/client";


export const manuallyCreateClaims = gql`
mutation ManuallyCreateClaims($treatyId: ID, $claims: [TreatyClaimData]) {
  manuallyCreateClaims(treaty_id: $treatyId, claims: $claims)
}
`

export const updateTreatyClaim = gql`
mutation UpdateClaimCreated($treatyClaimId: ID, $claims: TreatyClaimData) {
  updateClaimCreated(treaty_claim_id: $treatyClaimId, claims: $claims)
}
`

export const deleteTreatyClaim = gql`
mutation DeleteClaimCreated($treatyClaimId: ID) {
  deleteClaimCreated(treaty_claim_id: $treatyClaimId)
}
`

export const updateReceivablePayment = gql`
mutation UpdateReceivablePayment(
  $receivablePayments: ReceivablePaymentInput
  $receivablePaymentId: ID
  $treatyId: ID
) {
  updateReceivablePayment(
    receivable_payments: $receivablePayments
    receivable_payment_id: $receivablePaymentId
    treaty_id: $treatyId
  )
}

`


